import { Card, Checkbox, CheckboxOptionType, Col, ColProps, Row } from 'antd'

import { CheckboxChangeEvent, CheckboxGroupProps } from 'antd/es/checkbox'

import { useStyles } from './styles'

type Props = {
  options?: {
    label: React.ReactNode
    value: CheckboxOptionType['value']
    colProps?: ColProps
    onChange?: (e: CheckboxChangeEvent) => void
  }[]
} & Omit<CheckboxGroupProps, 'options'>

export const CheckboxCardGroup = ({ options, className, ...props }: Props) => {
  const { styles, cx } = useStyles()

  return (
    <Checkbox.Group className={cx(styles.checkboxGroup, className)} {...props}>
      <Row gutter={[12, 12]}>
        {options?.map(({ label, value, colProps, onChange }, idx) => (
          <Col key={idx} {...colProps}>
            <Card
              size="small"
              className={styles.cardRoot}
              classNames={{ body: styles.cardBody }}
            >
              <Checkbox
                value={value}
                className={styles.checkbox}
                onChange={onChange}
              >
                {label}
              </Checkbox>
            </Card>
          </Col>
        ))}
      </Row>
    </Checkbox.Group>
  )
}
